import { IconButton, styled, SxProps, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
    AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { ReactComponent as Additem } from '../../assets/icons/add.svg'
import { colors } from "../../constants/colors";

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ }) => ({
    border: `1px solid ${colors.themeMainColor}`,
    borderRadius: '8px',
    overflow: 'hidden',

}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ExpandMoreIcon sx={{
            fontSize: '1.8rem', color: colors.white,
        }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: colors.white,
    color: colors.black,
    flexDirection: 'row',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(180deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginRight: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    // borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

type Props = {
    titleName: string;
    required?: boolean;
    defaultExpanded?: boolean;
    expanded?: boolean;
    content: React.ReactNode;
    enableButtonLeft?: boolean;
    renderButtonLeft?: React.ReactNode;
    onClickButtonLeft?: any
    enableButtonRight?: boolean;
    renderButtonRight?: React.ReactNode;
    onClickButtonRight?: any
    titleButtonRight?: string;
    sxContainer?: SxProps;
    sxTitle?: SxProps;
    variant?: any;
    hiddenBorder?: boolean;
}

export default function AccordionCustom(props: Props) {
    const {
        titleName,
        required,
        defaultExpanded,
        expanded,
        content,
        enableButtonLeft,
        renderButtonLeft,
        onClickButtonLeft,
        enableButtonRight,
        renderButtonRight,
        onClickButtonRight,
        titleButtonRight,
        variant
    } = props
    return (
        <Accordion
            sx={{
                ...props.sxContainer,
                ...(!props.hiddenBorder && {
                    border: '1px solid #DDE1EB'
                })
            }}
            defaultExpanded={defaultExpanded}
            expanded={expanded}>
            <AccordionSummary
                sx={{
                    flexDirection: 'row-reverse',
                    gap: 2,
                    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                        transform: 'rotate(-180deg)',
                    },
                }}
                expandIcon={<ExpandMoreIcon sx={{ fontSize: 30 }} />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                <Typography variant={variant} sx={{ ...props.sxTitle, marginRight: '10px', mt: 2 }}>
                    {titleName}{required && <span style={{ color: 'red' }}>*</span>}</Typography>
                {enableButtonLeft && (renderButtonLeft ? renderButtonLeft : <IconButton onClick={(e) => {
                    e.stopPropagation()
                    onClickButtonLeft && onClickButtonLeft()
                }} >
                    <Additem />
                </IconButton>)}
                {enableButtonRight &&
                    <div style={{ marginLeft: 'auto', marginRight: '15px' }}>{renderButtonRight ? renderButtonRight :
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                            onClick={(e) => {
                                e.stopPropagation()
                                onClickButtonRight && onClickButtonRight()
                            }}>
                            <Additem />
                            <Typography>{titleButtonRight}</Typography>

                        </div>}
                    </div>
                }
            </AccordionSummary>
            <AccordionDetails>
                {content}
            </AccordionDetails>
        </Accordion>
    )
}
